Object.defineProperty(exports, "__esModule", { value: true });
exports.loadXapian = void 0;
var process = require("process");
var rxjs_1 = require("rxjs");
var xapianLoadedSubject;
function loadXapian(path) {
    if (!xapianLoadedSubject) {
        xapianLoadedSubject = new rxjs_1.AsyncSubject();
        if (!path) {
            path = process.cwd() + "/dist/xapianasm.js";
        }
        var xapian = require(path);
        global.termlistresult = [];
        global.Module = xapian;
        global.FS = xapian.FS;
        global.NODEFS = FS.filesystems.NODEFS;
        global.MEMFS = FS.filesystems.MEMFS;
        console.log("Xapian loaded");
        global.Module.onRuntimeInitialized = function () {
            console.log("Xapian runtime initialized");
            xapianLoadedSubject.next(true);
            xapianLoadedSubject.complete();
        };
    }
    return xapianLoadedSubject;
}
exports.loadXapian = loadXapian;
;
